import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Input, Header, Segment, Message, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";
import ActiveIcon from "../../../components/activeIcon";

//Actions
import { fetchFlights } from "../../../redux/actions/catalogs/flight/fetchFlights";
import { deleteFlight } from "../../../redux/actions/catalogs/flight/deleteFlight";

// Resources
import { scrollToTop } from "../../resources/utils";

export default function FlightList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const flightState = useSelector((state) => state.flightReducer);
  const { register, getValues } = useForm();
  const [sortedFligths, setSortedFligths] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  useEffect(() => {
    dispatch(fetchFlights(""));
    scrollToTop();
  }, []);

  useEffect(() => {
    setSortedFligths(flightState.flights || []);
  }, [flightState.flights]);

  if (flightState.fetching || flightState.processing) {
    return <Loader active inline />;
  }

  if (flightState.message === "resource deleted successfully") {
    dispatch(fetchFlights(""));
  }

  const handleDeleteFlight = (flight_id) => {
    dispatch(deleteFlight(flight_id));
  };

  const handleSearchFlight = () => {
    dispatch(fetchFlights(getValues("searchWord")));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearchFlight();
    }
  };

  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sorted = [...sortedFligths].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortedFligths(sorted);
    setSortConfig({ key, direction });
  };

  return (
    <>
      {flightState.error ? (
        <Message negative content={t(flightState.error)} />
      ) : (
        ""
      )}
      <Segment className="flex items-center justify-between">
        <HeaderCatalog title={t("flight_title")} message={flightState.message} to="/flights_new" />
        <Header as='h5' floated='right'>
          <Input type="text" placeholder={t("search") + "..."} action>
            <input name="searchWord" maxLength={100} onKeyDown={handleKeyDown} ref={register()} />
            <Button type="submit" onClick={() => handleSearchFlight()} icon="search" size="medium" />
          </Input>
        </Header>
      </Segment>

      <Table color="blue" striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell></Table.HeaderCell>
            <Table.HeaderCell>{t("flight_code")}<a href="#" onClick={() => handleSort("code")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell>{t("flight_airline")}<a href="#" onClick={() => handleSort("airline_name")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell>{t("type")}<a href="#" onClick={() => handleSort("type")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell>{t("route_title")}<a href="#" onClick={() => handleSort("routes")}>  <Icon name='sort' /></a></Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {sortedFligths.map((flight) => (
            <Table.Row key={flight.id}>
              <Table.Cell collapsing><ActiveIcon active={flight.active} /></Table.Cell>
              <Table.Cell><Link to={`/flight/${flight.id}/routes`}>{flight.code}</Link></Table.Cell>
              <Table.Cell>{flight.airline_name}</Table.Cell>
              <Table.Cell>{t(flight.type)}</Table.Cell>
              <Table.Cell>
                {JSON.parse(flight.routes).map(route => (
                  <div className="flex flex-col">
                    {route}
                  </div>
                ))}
              </Table.Cell>
              <Table.Cell collapsing>
                <Link to={`/flights/${flight.id}`}><Button circular color='blue' icon='pencil alternate' /></Link>
                <Modal
                  trigger={
                    <Button circular color='red' icon='trash alternate' />
                  }
                  content={t("flight_delete")}
                  actions={[
                    t("canceled_button"),
                    {
                      key: "eliminar",
                      content: t("delete_button"),
                      className: "delete_button icon_color",
                      onClick: () => handleDeleteFlight(flight.id),
                    },
                  ]}
                  size="tiny"
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
